import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';

export const routes: Routes = [    
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }, 
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages-route').then((m) => m.routes)
      }
    ]
  }
  
];
RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'});
